class BaseTooltip extends HTMLElement {
  constructor() {
    super();
  }

  get content() {
    return this.getAttribute("content");
  }

  get maxWidth() {
    return this.getAttribute("max-width") || 320;
  }

  get arrow() {
    return this.hasAttribute("arrow");
  }

  get placement() {
    return this.getAttribute("placement") || "top";
  }

  get options() {
    return {
      content: this.content,
      maxWidth: this.maxWidth,
      arrow: this.arrow,
      placement: this.placement
    }
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.content) {
      return;
    }

    return window.tippy(this, this.options);
  }
}

if (!customElements.get("base-tooltip")) {
  customElements.define("base-tooltip", BaseTooltip);
}

class ModalTooltip extends BaseTooltip {
  constructor() {
    super();
  }

  get selectors() {
    return {
      closeButton: "[data-tippy-close]"
    }
  };

  get options() {
    const that = this;

    return {
      ...super.options,
      allowHTML: true,
      trigger: "click",
      interactive: true,
      onShow(instance) {
        const closeButton = instance.popper.querySelector(that.selectors.closeButton);
        closeButton?.addEventListener("click", () => instance.hide());
      }
    }
  }

  get content() {
    const contentId = this.getAttribute("content");

    if (!contentId) {
      return null;
    }

    return document.getElementById(contentId);
  }
}

if (!customElements.get("modal-tooltip")) {
  customElements.define("modal-tooltip", ModalTooltip);
}
